<template lang="pug">
    include ../../media/pug/mixins
    +b.SIDEBAR-TAB.shop-cart(
        name="shop-cart"
    )
        template(v-slot:header="")
            +e.H2.title.title._size_md._theme_secondary {{ $t('BASKET') }}
            +e.P.placeholder.sidebar__placeholder
                | Для добавления страниц в корзину, выделите необходимые страницы на вкладке
                | #[span(class="link" v-on:click="showSketches") Эскизы] и нажмите на кнопку добавления в корзину
                v-icon(name="basket")
            +b.UL.shop-cart-list
                +e.LI.item
                    +e.col
                        +e.SPAN.key Всего страниц
                    +e.col
                        +e.SPAN.value 36 стр.
                +e.LI.item
                    +e.col
                        +e.SPAN.key Сумма заказа
                    +e.col
                        +e.SPAN.value 252 р.
            +e.actions
                +e.BUTTON.clear.btn.link(
                    type="button"
                ) Очистить корзину
                +e.BUTTON.order.btn._theme_fill._size_md(
                    type="button"
                ) Заказать
        template(v-slot:container="")
            +e.list
                cart-item(
                    v-for="item in 3"
                    v-bind:key="item"
                )

</template>

<script>
import CartItem from '@/components/modules/CartItem';
import SidebarTab from '@/components/partials/SidebarTab';

export default {
    components: {
        CartItem,
        SidebarTab
    },
    methods: {
        showSketches() {
            this.$store.commit('SET_CURRENT_SIDEBAR_TAB', 'PreviewViewer');
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/modules/shop-cart.sass"></style>
